import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Manual disclosure: `hidden` removes content from layout when closed; `aria-expanded` tells AT what happened.
 * We sync button label text for sighted users; screen readers use aria-expanded + content visibility.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'toggle',
  category: 'disclosure',
  title: 'Toggle panel',
  description: 'Button reveals and hides a details panel.',
  tags: [T.toggle, T.layout, T.a11y],
  html: `<h1>Settings</h1>

<!-- aria-expanded starts false; JS toggles it when the panel opens/closes -->
<button type="button" id="toggle" aria-expanded="false">Show panel</button>

<!-- native hidden attribute: no display until removed -->
<div id="panel" class="panel" hidden>
  <p>This panel toggles with the button.</p>
</div>`,
  css: `${shell}

h1 {
  color: var(--nogrok-preview-primary);
  font-size: 1.1rem;
  margin: 0 0 1rem;
}

#toggle {
  font: inherit;
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  border: 1px solid var(--nogrok-preview-outline);
  background: var(--nogrok-preview-surface-container);
  color: var(--nogrok-preview-on-surface);
  cursor: pointer;
}

.panel {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid var(--nogrok-preview-outline);
  background: var(--nogrok-preview-surface-container);
}`,
  js: `const btn = document.getElementById('toggle')
const panel = document.getElementById('panel')

btn?.addEventListener('click', () => {
  // Panel is "open" when hidden is absent (hasAttribute is false)
  const open = panel && !panel.hasAttribute('hidden')
  if (open) {
    panel?.setAttribute('hidden', '')
    btn.setAttribute('aria-expanded', 'false')
    btn.textContent = 'Show panel'
  } else {
    panel?.removeAttribute('hidden')
    btn.setAttribute('aria-expanded', 'true')
    btn.textContent = 'Hide panel'
  }
})`,
}

export default preset
